import { __assign, __makeTemplateObject } from "tslib";
import { Button as MuiButton, styled } from '@mui/material';
import { CircularProgress } from '../circular-progress';
export var Children = styled('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var Spinner = styled(CircularProgress)(function () { return ({
    position: "absolute",
}); });
export var StyledButton = styled(MuiButton, {
    shouldForwardProp: function (prop) { return !['loading', 'rounded'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, loading = _a.loading, rounded = _a.rounded, size = _a.size;
    return (__assign(__assign({}, (loading && {
        'span:not(.MuiCircularProgress-root)': {
            opacity: 0,
        },
    })), (rounded && __assign(__assign(__assign({ borderRadius: 20, paddingLeft: theme.spacing(5), paddingRight: theme.spacing(5) }, (size === 'small' && {
        borderRadius: 16,
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5), // 20,
    })), (size === 'medium' && {
        borderRadius: 20,
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5), // 40,
    })), (size === 'large' && {
        borderRadius: 28,
        paddingLeft: theme.spacing(5.5),
        paddingRight: theme.spacing(5.5), // 44,
    })))));
});
var templateObject_1;
// export const StyledButton = styled(MuiButton, {
//   shouldForwardProp: prop => !['variant', 'color'].includes(String(prop)),
// })<ButtonProps>(({ theme,variant, color }) => ({
//   ...(variant === "round" && {
//     borderRadius: `28px`,
//     paddingLeft:  theme.spacing(10),
//     paddingRight: theme.spacing(10),
//     ...(color && color !== 'inherit' && {
//       color: theme.palette[color].contrastText,
//       borderColor: theme.palette[color].main,
//       backgroundColor: theme.palette[color].main,
//       boxShadow: `none`,
//       "&:hover": {
//         backgroundColor: theme.palette[color].main,
//         boxShadow: `0 3px 6px 0 rgba(0, 0, 0, 0.32)`,
//         ".MuiTouchRipple-root": {
//           backgroundColor: alpha(theme.palette.common.white, 0.08)
//         }
//       },
//       "&:focus": {
//         backgroundColor: theme.palette[color].main,
//         ".MuiTouchRipple-root": {
//           backgroundColor: alpha(theme.palette.common.white, 0.12)
//         }
//       },
//       "&:active": {
//         backgroundColor: theme.palette[color].main,
//         boxShadow: `0 3px 6px 0 rgba(0, 0, 0, 0.32)`,
//         ".MuiTouchRipple-root": {
//           backgroundColor: alpha(theme.palette.common.white, 0.16)
//         }
//       },
//       "&.Mui-disabled": {
//         background: alpha(theme.palette.secondary.main, 0.16),
//         color: alpha(theme.palette.secondary.main, 0.48)
//       }
//     })
//   })
// }));
//# sourceMappingURL=styled.js.map